"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTournamentsV2 = getTournamentsV2;
exports.getTournaments = getTournaments;
exports.searchTournaments = searchTournaments;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const api_1 = require("..");
async function getTournamentsV2(request) {
    const api = api_1.ApiManager.getApi(betweb_openapi_axios_1.TournamentsApi);
    return await api.getTournamentsV2(request);
}
async function getTournaments(request) {
    const api = api_1.ApiManager.getApi(betweb_openapi_axios_1.TournamentsApi);
    return await api.getTournaments(request);
}
async function searchTournaments(request) {
    const api = api_1.ApiManager.getApi(betweb_openapi_axios_1.TournamentsApi);
    return await api.searchTournaments(request);
}
//# sourceMappingURL=api.js.map